<template>
    <div class="custom-form-group" :class="[formGroupClass, {'is-invalid': getError(name)}]">
        <label class="form-label" :for="uniqid" v-if="label">{{ label }}</label>
        <div class="form-check" :class="formCheckClass" :key="i" v-for="(option, i) in options">
            <input
                :type="type"
                :id="uniqid+i"
                :name="name"
                :value="option.value"
                :disabled="option.disabled"
                class="form-check-input"
                :class="{'is-invalid': getError(name)}"
                :aria-describedby="uniqid+'-feedback'"
                v-model="localValue"
            />
            <label class="form-check-label" :for="uniqid+i">
                {{ option.label }}
            </label>
        </div>
        <div class="invalid-feedback" :id="uniqid+'-feedback'">
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>

import uniqid from 'uniqid'

export default {

    props: {
        value: {
            required: true
        },
        type: {
            default: 'checkbox'
        },
        name: {
            required: true
        },
        label: {
            default: false
        },
        formGroupClass: {
            default: null
        },
        formCheckClass: {
            default: null
        },
        options: {
            required: true
        },
        customErrorMessage: {
            default: null
        }
    },

    inject: [
        'getError',
        'clearError'
    ],

    data () {
        return {
            localValue: this.value,
            uniqid: uniqid()
        }
    },

    watch: {
        value: {
            deep: true,
            handler (val) {
                this.localValue = val
            }
        },
        localValue: {
            deep: true,
            handler () {
                this.updateValue()
            }
        }
    },

    computed: {
        errorMessage () {
            if (this.getError(this.name) && Array.isArray(this.getError(this.name))) {
                if (this.customErrorMessage) {
                    return this.customErrorMessage
                } else {
                    return this.getError(this.name)[0]
                }
            }
            return ''
        }
    },

    methods: {
        updateValue () {
            this.$emit('input', this.localValue)
            this.clearError(this.name)
        }
    }

}
</script>
